import { Headline, Text, TextButton } from '@oneaudi/unified-web-components';
import { NoResultContainer } from '~/app/compositions/sidebar/accessories-equiptments/styles/accessories-equipment-style';
import { useI18n } from '~/app/i18n/i18n';

export const NoResult = ({ onClearSearch }: { onClearSearch: () => void }) => {
	const { i18n } = useI18n();

	return (
		<NoResultContainer>
			<Headline variant={{ order: '3', type: 'headline', weight: 'normal' }} tag="h4">
				{i18n('ngc.equipmentAndAccessories.noResults')}
			</Headline>
			<Text tag="p" variant={{ order: '1', style: 'normal', type: 'copy' }}>
				{i18n('ngc.equipmentAndAccessories.noResults.infoText')}
			</Text>
			<TextButton onClick={onClearSearch} size="sm" variant="secondary">
				{i18n('ngc.equipmentAndAccessories.resetSearch')}
			</TextButton>
		</NoResultContainer>
	);
};
